export default {
  app: {
    featured: 'विशेष रुपले प्रदर्शित',
    random: 'अनियमित',
    explore: 'अन्वेषण गर्नुहोस्',
    keywords: 'मुख्य-शब्द',
    search: 'खोज',
  },
  explore: {
    filters: 'फिल्टर',
    resetFilters: 'फिल्टर रिसेट गर्नुहोस्',
    addKeyword: 'मुख्य-शब्द जोड्नुहोस्',
  },
  recipe: {
    contributedBy: 'योगदानी',
    ingredients: 'सामग्री',
    directions: 'तयारी',
    fullRecipe: 'पुरा नुस्खा यहाँ हेर्नुहोस्',
    similarDrinks: 'उस्तै पेय',
  },
  featuredRecipes: {
    loadMore: 'अझ विधि हेर्नुहोस',
  },
  recipeFind: {
    filterBy: 'छाने',
    name: 'नाम',
    ingredients: 'सामग्री',
    keywords: 'मुख्य-शब्द',
    searchForIngredients:
      'तपाइँ उनीहरु को बीच रिक्त स्थान छोडेर धेरै सामग्रीको लागी खोज्न सक्नुहुन्छ',
    searchForKeywords:
      'तपाइँ उनीहरु को बीच रिक्त स्थान छोडेर धेरै मुख्य-शब्दको लागी खोज्न सक्नुहुन्छ',
  },
  recipeList: {
    viewRecipe: 'नुस्खा हेर्नुहोस्',
  },
  recipeToolbar: {
    print: 'छाप्नुहोस्',
    share: 'साझा गर्नुहोस्',
    shareOnFacebook: 'फेसबुकमा साझा गर्नुहोस्',
    shareOnTwitter: 'ट्विटर मा साझा गर्नुहोस्',
    copyURL: 'यूआरएल प्रतिलिपि गर्नुहोस्',
    hideImage: 'चित्र लुकाउनुहोस्',
  },
  favorites: {
    removeAllFavorites: 'सबै मनपर्ने हटाउनुहोस्',
    noFavoriteDrinks: 'तपाइँसँग कुनै मनपर्ने पेय छैन',
    removeFavoritesPrompt: 'के तपाइँ पक्का हुनुहुन्छ कि तपाइँ सबै मनपर्ने हटाउन चाहानुहुन्छ?',
    delete: 'हटाउनुहोस्',
    cancel: 'रद्द गर्नुहोस्',
  },
  keywordList: {
    enterYourKeyword: 'तपाइँको मुख्य शब्द दर्ज गर्नुहोस्',
  },
  search: {
    findYourDrink: 'तपाइँको पेय खोज्नुहोस्',
  },
  pageNotFound: {
    pageNotFound: 'तपाईंले खोजिरहनुभएको पृष्ठ भेटिएन।',
    backToHome: 'घर फिर्ता',
  },
};
